// src/Components/Invoice/InvoiceModal.js

import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import logo from "../Assets/gold.png";
import "../Pages/User/css/Orders.css";

const InvoiceDetails = ({ orderId, show, onHide }) => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const invoiceRef = useRef();

  const fetchInvoiceData = async (orderID) => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://tarunika.backendapihub.com/invoice/view",
        { order_id: orderID },
        {
          headers: {
            accept: "application/json",
            "access-token": sessionStorage.getItem("auth"),
          },
        }
      );
      if (response.data.status === "success") {
        const [firstInvoice] = response.data.data;
        setInvoiceData(firstInvoice);
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
    } finally {
      setLoading(false);
    }
  };

// src/Components/Invoice/InvoiceModal.js
const handleDownloadPDF = async () => {
    if (!invoiceRef.current) return;
    setPdfLoading(true);
  
    try {
      // Create a fixed-size container for PDF generation
      const printContainer = document.createElement("div");
      printContainer.style.position = "absolute";
      printContainer.style.left = "-9999px";
      printContainer.style.width = "794px"; // A4 width in pixels (210mm)
      printContainer.style.background = "white";
      printContainer.style.padding = "20px";
      printContainer.style.boxSizing = "border-box";
      
      // Clone and reset responsive styles
      const clone = invoiceRef.current.cloneNode(true);
      clone.style.width = "100%";
      clone.style.minWidth = "0";
      clone.style.transform = "none";
      clone.querySelectorAll('*').forEach(el => {
        el.style.minWidth = "0";
        el.style.maxWidth = "none";
        el.style.flexShrink = "0";
      });
      
      printContainer.appendChild(clone);
      document.body.appendChild(printContainer);
  
      // Use higher scale for better quality
      const canvas = await html2canvas(printContainer, {
        scale: 3,
        useCORS: true,
        logging: false,
        width: printContainer.offsetWidth,
        height: printContainer.scrollHeight,
        windowWidth: printContainer.scrollWidth,
        windowHeight: printContainer.scrollHeight
      });
  
      document.body.removeChild(printContainer);
  
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
      let position = 0;
      const pageHeight = pdf.internal.pageSize.getHeight();
  
      while (position < pdfHeight) {
        if (position > 0) pdf.addPage();
        const heightThisPage = Math.min(pageHeight, pdfHeight - position);
        
        pdf.addImage(
          imgData,
          "PNG",
          0,
          -position,
          pdfWidth,
          pdfHeight
        );
        
        position += pageHeight;
      }
  
      pdf.save(`Invoice-${orderId}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setPdfLoading(false);
    }
  };

  useEffect(() => {
    if (show && orderId) {
      fetchInvoiceData(orderId);
    }
  }, [show, orderId]);

  const isMaharashtra = invoiceData?.state?.toLowerCase() === "maharashtra";

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflowX: "auto" }}>
        {loading ? (
          <p>Loading invoice...</p>
        ) : invoiceData ? (
          <div ref={invoiceRef} className="invoice-container">
            <div className="invoice-header">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <img src={logo} alt="Company Logo" style={{ height: "60px" }} />
                </div>
                <div className="text-end">
                  <h4>Order ID: #{invoiceData.order_no}</h4>
                  <p>Date: {invoiceData.order_date}</p>
                </div>
              </div>
            </div>

            <div className="invoice-sections">
              <div className="invoice-section">
                <h5>Sold By: Tarunika</h5>
                <p>GSTIN: 27ASKPS4284L1ZX</p>
              </div>

              <div className="invoice-section">
                <h5>Customer Information</h5>
                <p><strong>{invoiceData.customer_name}</strong></p>
                <p><b>Address:</b> {invoiceData.address1}, {invoiceData.address2} {invoiceData.city}, {invoiceData.state}, {invoiceData.pincode}</p>
                <p><b>Mobile:</b> +91 {invoiceData.mobile}</p>
                <p><b>Email:</b> {invoiceData.email}</p>
              </div>
            </div>

            <div className="invoice-products">
              <h5>Product Details</h5>
              <div className="table-scroll-container">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>HSN Code</th>
                      <th>Rate</th>
                      <th>Qty</th>
                      <th>Tax Rate</th>
                      {isMaharashtra ? (
                        <>
                          <th>CGST</th>
                          <th>SGST</th>
                        </>
                      ) : (
                        <th>IGST</th>
                      )}
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData.product_details?.map((product, index) => (
                      <tr key={index}>
                        <td>{product.product || "N/A"}</td>
                        <td>{product.hsn_code || "N/A"}</td>
                        <td>₹{product.rate || "0"}</td>
                        <td>{product.qty || "0"}</td>
                        <td>{product.tax_rate || "0"}%</td>
                        {isMaharashtra ? (
                          <>
                            <td>{product.tax?.[0]?.cgst || "0"}</td>
                            <td>{product.tax?.[0]?.sgst || "0"}</td>
                          </>
                        ) : (
                          <td>{product.tax?.[0]?.igst || "0"}</td>
                        )}
                        <td>₹{product.amount || "0"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="invoice-summary">
              <div className="row justify-content-end">
                <div className="col-md-6">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td>Subtotal:</td>
                        <td className="text-end">₹{invoiceData.total_price}</td>
                      </tr>
                      <tr>
                        <td>Discount:</td>
                        <td className="text-end">₹{invoiceData.promocode}</td>
                      </tr>
                      <tr>
                        <td>Shipping:</td>
                        <td className="text-end">₹{invoiceData.shipping_price}</td>
                      </tr>
                      <tr className="table-active">
                        <td><strong>Total Amount:</strong></td>
                        <td className="text-end"><strong>₹{invoiceData.total_amount}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="invoice-footer mt-4">
              <div className="row">
                <div className="col-md-6">
                  <h6>Customer Care</h6>
                  <p>+91 70213 07984</p>
                </div>
                <div className="col-md-6">
                  <h6>Registered Address</h6>
                  <p>
                    B1-31, Target Mall, Chandavarkar Road, Opp. Rajmahal Hotel,
                    Borivali West, Mumbai - 400092.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>No invoice data available</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          style={{
            backgroundColor: "#ffd404",
            color: "#000",
            borderColor: "#790101",
          }}
          onClick={handleDownloadPDF}
          disabled={pdfLoading}
        >
          {pdfLoading ? "Generating PDF..." : "Download Invoice"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceDetails;
